<script lang="ts">
  import { uiApi } from "$lib/ui-api";
  import { onMount } from "svelte";
  import type { ISvgMapFunctions } from "../_helper/fixture-manager";

  export let svgUrl = "";
  export let onLoadComplete = (fns: ISvgMapFunctions) => {};

  let svgMapEl: HTMLDivElement;
  let svgText = "Loading...";

  function initMap() {
    if (!svgMapEl) {
      return;
    }
    uiApi
      .getRaw(svgUrl, undefined, undefined)
      .then(r => r.text())
      .then(svg => {
        svgText = svg;
      })
      .catch(err => {
        console.log(err);
        svgText = "Failed to load map, please refresh the page.";
      });
    // .finally(() => {
    onLoadComplete({ onClick, handleSectionFilter, cleanMap });
    // });
  }

  // On click filter
  function onClick(ev: Event, blocks: Set<string>, fixtureContainer: HTMLElement | undefined) {
    ev.stopImmediatePropagation();
    if (!svgMapEl || !fixtureContainer) {
      return;
    }

    let sectionEle = ev.target as HTMLElement;
    if (!ev?.target) {
      return;
    }

    const paths = fixtureContainer.querySelectorAll("path");
    const block = `${sectionEle?.dataset?.block?.toLowerCase()}` || "";
    const hasBlock = blocks.has(block);

    if (hasBlock) {
      handleBlock(fixtureContainer, sectionEle, paths);
      return;
    }

    const stdSection = sectionEle.dataset.section || "";
    if (!stdSection) {
      return;
    }
    handleSection(fixtureContainer, sectionEle, paths);
  }

  // Used on Map click
  function handleBlock(fixtureContainer: HTMLElement, sectionEle: HTMLElement, paths: NodeListOf<SVGPathElement>) {
    const classes = sectionEle.classList.value;
    // Active class is defined in venue controller BE
    const isActive = classes.includes("active");
    // If block is clicked and filter remove filter
    if (isActive) {
      fixtureContainer.classList.remove("filter");
      sectionEle.classList.remove("active");
      return;
    }

    const block = sectionEle.dataset.block;
    fixtureContainer.classList.add("filter");

    for (const path of paths) {
      const dataBlock = path.getAttribute("data-block"); // Get the data-block attribute
      if (block === dataBlock) {
        path.classList.add("active");
      } else {
        path.classList.remove("active");
      }
    }
  }
  // Used on Map click
  function handleSection(fixtureContainer: HTMLElement, sectionEle: HTMLElement, paths: NodeListOf<SVGPathElement>) {
    // Element click classlist
    const classes = sectionEle.classList.value;
    const stdSection = sectionEle.dataset.section as string;
    // Active class is defined in venue controller BE
    const isActive = classes.includes("active");
    // If block is clicked and filter remove filter
    if (isActive) {
      fixtureContainer.classList.remove("filter");
      for (const path of paths) {
        path.classList.remove("active");
      }
      return;
    }

    // If first click
    fixtureContainer.classList.add("filter");
    const catList = new Set([stdSection]);
    let tags: string | string[] = sectionEle.dataset.tags || "";
    if (tags) {
      tags.split(",").forEach(t => catList.add(t));
    }

    for (const path of paths) {
      const pathSection = path.dataset.section || "";
      const pathTags = path.dataset.tags || "";
      const x = pathTags.split(",").filter(v => v);
      const union = [pathSection, ...x];
      union.forEach(u => {
        if (catList.has(u)) {
          path.classList.add("active");
        } else {
          path.classList.remove("active");
        }
      });
    }
  }

  // Used on filter
  function handleSectionFilter(fixtureContainer: HTMLElement | undefined, categories?: string | string[]) {
    if (!fixtureContainer) {
      return;
    }

    if (!categories?.length) {
      fixtureContainer.classList.remove("filter");
      const paths = fixtureContainer.querySelectorAll("path");
      for (const path of paths) {
        path.classList.remove("active");
      }
      return;
    }

    const filterCatMap = new Set<string>();
    if (Array.isArray(categories)) {
      categories.forEach(v => filterCatMap.add(v));
    } else {
      filterCatMap.add(categories);
    }

    const paths = fixtureContainer.querySelectorAll("path");
    fixtureContainer.classList.add("filter");
    for (const path of paths) {
      const section = path.getAttribute("data-section") || "";
      const tags = (path.getAttribute("data-tags") || "").split(",");
      const pathDet = [section, ...tags];
      const hasSection = pathDet.some(v => filterCatMap.has(v));
      if (hasSection) {
        path.classList.add("active");
      } else {
        path.classList.remove("active");
      }
    }
  }

  function cleanMap(fixtureContainer: HTMLElement | undefined) {
    if (!fixtureContainer) {
      return;
    }
    fixtureContainer.classList.remove("filter");
    const paths = fixtureContainer.querySelectorAll("path");
    for (const path of paths) {
      path.classList.remove("active");
    }
  }

  onMount(initMap);
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div id="venue" class="map" on:click bind:this={svgMapEl}>
  {@html svgText}
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .map {
    :global(svg) {
      width: 100%;
      max-height: 27.5vh;
      @include desktop {
        max-height: 75vh;
      }
    }
  }
  .map :global(path) {
    transition: fill 0.2s ease-in-out;
  }
</style>
